export const dashboardConstants = {
    

    GETALL_REQUEST: 'DASHBOARD_GETALL_REQUEST',
    GETALL_SUCCESS: 'DASHBOARD_GETALL_SUCCESS',
    GETALL_FAILURE: 'DASHBOARD_GETALL_FAILURE',

    

};